import { PropsWithChildren } from 'react';
import { FlexContainer } from '../../ContentContainers/FlexContainer';
import { Box, useTheme } from '@mui/material';

export interface FullScreenPageProps extends PropsWithChildren {
  showBorderTop?: boolean;
}

export const FullScreenPage = ({
  showBorderTop = true,
  children,
}: FullScreenPageProps) => {
  const theme = useTheme();

  return (
    <FlexContainer
      direction="column"
      backgroundColor="neutralLight.main"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
    >
      <FlexContainer
        direction="column"
        alignItems="center"
        justifyContent="center"
        flexGrow={1}
        overflow="auto"
        width="100%"
        transparent
        sx={{ position: 'relative' }}
      >
        {children}
      </FlexContainer>

      {showBorderTop && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            height: 5,
            backgroundColor: theme.palette.primaryAccent?.main,
            zIndex: 111,
          }}
        />
      )}
    </FlexContainer>
  );
};
